// extracted by mini-css-extract-plugin
export default {"container":"Status_container__C8rnr","text":"Status_text__hAB6q"};